module.exports = __webpack_public_path__ + "img/devise.ce01677c.jpg";